import { Modal } from '@dealstack/frontend/shared/components/fundament/Modal/Modal';
import { PrivacyPolicyContent } from '@dealstack/frontend/shared/components/TermsModals/PrivacyPolicyContent';
import styled from 'styled-components';

interface Props {
	className?: string;
	onClose: () => void;
}

const PrivacyPolicyModal = ({ onClose, className }: Props) => {
	return (
		<Modal className={className} onClose={onClose}>
			<PrivacyPolicyContent />
		</Modal>
	);
};

const Styled = styled(PrivacyPolicyModal)`
	white-space: pre-line;

	* {
		line-height: 1.2em;
	}

	strong {
		font-weight: bold;
	}

	i {
		font-style: italic;
	}

	ul {
		list-style: disc;
		padding-left: 1.5em;

		li {
			margin: 0.5em;
		}

		ul {
			list-style: circle;
		}
	}
`;

export { Styled as PrivacyPolicyModal };
